import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import dayjs from "dayjs";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg";
import CreateEntryModal from "./CreateEntryModal";
import { getAllInterCompanyEliminationsApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const InterCompanyEliminationsEntries = ({
  setEliminationScreen,
  history,
  consolID,
}) => {
  const [interCompanyEliminations, setInterCompanyEliminations] = useState([]);

  useEffect(() => {
    getInterCompanyEliminations();
  }, []);

  const getInterCompanyEliminations = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getAllInterCompanyEliminationsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const eliminationsData = response?.data;

          setInterCompanyEliminations(
            eliminationsData?.intercompanyEliminations ?? [],
          );
        } else {
          setInterCompanyEliminations([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get inter company eliminations",
            "error",
          );
        }
      })
      .catch((error) => {
        setInterCompanyEliminations([]);
        swal(
          "Error",
          error?.response?.data?.error ||
            "Unable to populate inter company eliminations",
          "error",
        );
      });
  };

  return (
    <>
      <div className={icrCss.header} style={{ justifyContent: "end" }}>
        <Button
          btnColor={buttoncss.greyBg}
          label="View Workings"
          onClick={() => setEliminationScreen(1)}
        />
        <Button
          btnColor={buttoncss.primary}
          label="Populate FS"
          onClick={() => {
            history.push(`/myfinV2/console-populatefs/${consolID}`);
          }}
        />
      </div>
      <div className={icrCss.entrytableCtn} style={{ paddingTop: "20px"}}>
        <table className={icrCss.entrytable}>
          <thead>
            <tr>
              <th className="text-left" style={{paddingLeft: "20px"}}>Particulars</th>
              <th className="text-center" style={{ width: "130px" }}>
                Date
              </th>
               <th style={{ textAlign: "right", paddingRight: "25px" }}>Current year</th>
              <th style={{ textAlign: "right", paddingRight: "20px" , whiteSpace: "noWrap"}}>Previous year</th>

              <th className="text-left" style={{ width: "300px" }}>
                Remarks
              </th>
            </tr>
          </thead>

          <tbody>
            {interCompanyEliminations.length > 0 &&
              interCompanyEliminations.map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {group.adjustments.map((row, rowIndex) => (
                    <tr key={`${groupIndex}-${rowIndex}`}>
                      <td className="text-left">{row.levelThree}</td>
                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-center"
                        >
                          {group.adjustmentDate
                            ? dayjs(group.adjustmentDate).format("DD-MMM-YYYY")
                            : ""}
                        </td>
                      )}

                      <td className={icrCss.amount}>
                        {row.currentYear !== null && row.currentYear !== undefined
                          ? (Number(row.currentYear) < 0
                              ? `(${Math.abs(Number(row.currentYear)).toLocaleString("en-IN")})`
                              : Number(row.currentYear).toLocaleString("en-IN"))
                          : ""}
                      </td>

                      <td className={icrCss.amount}>
                        {row.previousYear !== null && row.previousYear !== undefined
                          ? (Number(row.previousYear) < 0
                              ? `(${Math.abs(Number(row.previousYear)).toLocaleString("en-IN")})`
                              : Number(row.previousYear).toLocaleString("en-IN"))
                          : ""}
                      </td>

                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-left"
                        >
                          {group.remarks}
                        </td>
                      )}
                    </tr>
                  ))}

                  <tr className={icrCss.groupSeparator}>
                    <td colSpan={6}></td>
                  </tr>
                </React.Fragment>
              ))}

            {interCompanyEliminations.length === 0 && (
              <tr>
                <td colSpan={6}>No Adjustment Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default InterCompanyEliminationsEntries;
